<template>
  <card
    title="משימות להיום"
    :linkTo="`/tasks?notCompleted=true&dueDateBefore=${format(addDays(Date(), 1), 'YYYY-MM-DD')}`"
    actionButton="לכל המשימות להיום"
    :number="number"
    :loading="loading"
    :error="error"
  />
</template>

<script>
import { format, addDays } from 'date-fns';
import { getApi } from '@/api';
import Card from "./Card.vue";

export default {
  data() {
    return {
      number: 0,
      loading: false,
      error: false
    };
  },

  computed: {},

  methods: {
    format,
    addDays,
    fetchData() {
      this.loading = true;
      getApi()
        .then(api => {
          let params = {
            dueDateBefore: format(addDays(Date(), 1), 'YYYY-MM-DD'),
            notCompleted: true
          };
          return api.get('/tasks', { params })
        })
        .then(({ data }) => {
          this.number = data.totalResults;
        })
        .catch(err => {
          console.log(err);
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        })
    }
  },

  props: [],

  mounted() {
    this.fetchData();
  },

  components: {
    Card
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
